export default "__VITE_ASSET__d85e7a99__"